module.exports = __webpack_public_path__ + "static/media/sendMessageBlack.08f363d0.svg";